import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  finishLoginModalOpen: false
};

const confirmationModalSlice = createSlice({
  name: 'confirmation',
  initialState,
  reducers: {
    setConfirmationModal: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
    setFinishLoginModal: (state, action: PayloadAction<boolean>) => {
      state.finishLoginModalOpen = action.payload;
    }
  }
});

export const { setConfirmationModal, setFinishLoginModal } = confirmationModalSlice.actions;
export const confirmationModalReducer = confirmationModalSlice.reducer;
